import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { H, Flex, Text, DropdownOptions, TooltipPopup } from 'dash-ui';
import ForgotPasswordForm from 'pages/authentication/ForgotPasswordPage/components/ForgotPasswordForm/ForgotPasswordForm';
import AuthenticationPageLayout from 'flow-components/AuthenticationPageLayout/AuthenticationPageLayout';

function ForgotPasswordPage() {
  const { t } = useTranslation('pages', { keyPrefix: 'forgotPasswordPage' });
  const theme = useTheme();
  return (
    <AuthenticationPageLayout>
      <DropdownOptions />
      <TooltipPopup />
      <Flex flexDirection="column" w={334}>
        <Flex flexDirection="column">
          <H sm bold as={4}>{t`welcomeHeader`}</H>
          <Text color={theme.colors.n70}>{t`welcomeSubHeader`}</Text>
        </Flex>
        <ForgotPasswordForm />
      </Flex>
    </AuthenticationPageLayout>
  );
}

export default ForgotPasswordPage;
